/**
 * `RpcError.code === "SERVER_UNAVAILABLE"` için özel ekran.
 *
 * 27.09.2026: sunucu kapalıyken servis işçisi kabuğu önbellekten açtı, Worker
 * betiği gelmedi ve ekran "veritabanı Worker'ı çöktü" dedi. Teşhis sırasında
 * site verisi temizlendi ve OPFS'teki defter silindi. Bu ekranın tek işi o
 * hatayı bir daha yaptırmamak: veri cihazda ve sağlam, beklemek yeter.
 */

import { errorDetail, errorText } from "../lib/rpcError";
import { Button, Notice } from "../ui/primitives";
import { M } from "../dil";

export interface ServerUnavailableScreenProps {
  readonly error: unknown;
  readonly onRetry: () => void;
}

export function ServerUnavailableScreen({ error, onRetry }: ServerUnavailableScreenProps) {
  const detail = errorDetail(error);
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center p-6">
      <div className="pf-card p-5">
        <h1 className="text-[18px] font-semibold text-ink">{errorText(error)}</h1>
        <p className="mt-3 text-[13px] leading-relaxed text-ink">
          {M.kabuk.sunucuYok.dosyalar}
        </p>
        <p className="mt-3 text-[13px] leading-relaxed text-muted">
          {M.kabuk.sunucuYok.yerinde}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="primary" onClick={onRetry}>
            {M.kabuk.sunucuYok.yenidenDene}
          </Button>
        </div>

        <div className="mt-5">
          <Notice tone="warn" title={M.kabuk.sunucuYok.temizlemeyinBaslik}>
            <p>{M.kabuk.sunucuYok.temizlemeyin}</p>
          </Notice>
        </div>

        {detail !== undefined && (
          <details className="mt-4">
            <summary className="cursor-pointer text-[12px] text-muted">{M.kabuk.sunucuYok.teknikAyrinti}</summary>
            <pre className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap text-[11px] text-muted">{detail}</pre>
          </details>
        )}
      </div>
    </main>
  );
}
